import http from "./http";
import { selectAllCusFun } from '@/assets/api/sellOrder';
import { getSupplierConfig } from '@/assets/api/systemSetting';
import util from '@/assets/common/util';

export function loginExecution () {
  // 获取副仓列表
  http.post({
    SERVICE_ID: '10009',
    OTYPE: 78,
    GYS_ID_LIST: [sessionStorage.getItem('tcId')]
  }).then((res) => {
    sessionStorage.setItem('subWarehouseList', JSON.stringify(res))
  }).catch((err) => {
    console.log('src\assets\common\loginExecution.js, 10009-78', err);
  })

  // 获取所有客户列表
  selectAllCusFun({
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId'))
  }).then((res) => {
    sessionStorage.setItem('allCustomerList', JSON.stringify(res))
  }).catch((err) => {
    console.log('src\assets\common\loginExecution.js, 10005-5', err);
  })

  // 获取第三方供应商列表
  http.post({
    SERVICE_ID: '10179',
    OTYPE: 12,
    GYS_ID: Number(sessionStorage.getItem('tcId'))
  }).then((res) => {
    sessionStorage.setItem('thirdSupplierList', JSON.stringify(res))
  }).catch((err) => {
    console.log('src\assets\common\loginExecution.js, 10179-12', err);
  })

  // 获取主副供应商在用项目点列表
  http.post({
    SERVICE_ID: '10005',
    OTYPE: 8,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
  }).then((res) => {
    sessionStorage.setItem('usingProjectList', JSON.stringify(util.listRemoveDuplicates(res[0].project)))
  }).catch((err) => {
    console.log('src\assets\common\loginExecution.js, 10005-8', err);
  });

  http.post({
    SERVICE_ID: '10202',
    OTYPE: 52,
    COMPANY_ID: Number(sessionStorage.getItem('tcId')), // 生产企业ID
    COMPANY_TYPE: 2, // 公司类型（1：团餐，2：供应商）
  }).then((res) => {
    sessionStorage.setItem('sourceCompanyList', JSON.stringify(util.listRemoveDuplicates(res)))
  }).catch((err) => {
    console.log('src\assets\common\loginExecution.js, 10202-52', err);
  });

  getSupplierConfig().then((res) => {
    sessionStorage.setItem('config', JSON.stringify(res[0].list[0]))
  }).catch((err) => {
    console.log('src\assets\common\loginExecution.js, 10017-6', err);
  });
}


// WEBPACK FOOTER //
// ./src/assets/common/loginExecution.js